import { useEffect, useState } from "react";
import Modal from "./modal";

export default function JobList() {
  const [jobs, setJobs] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);

  const [form, setForm] = useState({
    id: "",
    position: "",
    location: "",
    type: "",
    department: "",
    responsibilities: "",
    requirements: "",
    skills: "",
  });

  // Load jobs
  useEffect(() => {
    fetch("https://arkane.in/apijob/read.php")
      .then(res => res.json())
      .then(data => setJobs(Array.isArray(data) ? data : []))
      .catch(() => setJobs([]));
  }, []);

  // Populate form when job selected
  useEffect(() => {
    if (selectedJob) {
      setForm({
        id: selectedJob.id,
        position: selectedJob.position,
        location: selectedJob.location,
        type: selectedJob.type,
        department: selectedJob.department,
        responsibilities: selectedJob.responsibilities,
        requirements: selectedJob.requirements,
        skills: selectedJob.skills,
      });
    }
  }, [selectedJob]);

  const remove = async (id) => {
    await fetch("https://arkane.in/apijob/delete.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id }),
    });

    setJobs(prev => prev.filter(j => j.id !== id));
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const updateJob = async (e) => {
    e.preventDefault();

    const res = await fetch("https://arkane.in/apijob/update.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(form),
    });

    const result = await res.json();

    if (result.success) {
      setJobs(prev =>
        prev.map(j => (j.id === form.id ? form : j))
      );
      setOpen(false);
    }
  };

  return (
    <div className="dash-container">
      <div className="object-container object-container-career">
        <div className="layout-services">

          {jobs.map(job => (
            <div className="services-items career-container" key={job.id}>
              <span className="service-title">
                <span className="--h4 split-grid">Job Title: <p>{job.position}</p></span>
                <span className="--h4 split-grid">LOCATION: <p>{job.location}</p></span>
                <span className="--h4 split-grid">Job TYPE: <p>{job.type}</p></span>
                 <span className="--h4 split-grid">Department/Team: <p>{job.department}</p></span>

                  <span className="--h4 text-upper">Job Description:</span>
                    ‍ <p>{job.requirements}</p> <br/>

                    <span className="--h4 text-upper">Key Responsibilities:</span>
                       <p> {job.responsibilities
                              ?.split('-')
                              .filter(item => item.trim() !== '')
                              .map((item, index) => (
                                <li key={index}>{item.trim()}</li>
                              ))}
                              </p> <br/>     
                   
                    <span className="--h4 text-upper">Required Skills:</span>
                    <p>{job.skills
                     ?.split('-')
                              .filter(item => item.trim() !== '')
                              .map((item, index) => (
                                <li key={index}>{item.trim()}</li>
                              ))}
                    </p>
              </span>

              <div className="form-space">
                <button
                onClick={() => remove(job.id)}
                className="nav-link contact--button active delete-section"
              >
                Delete
              </button>

              <button
                onClick={() => {
                  setSelectedJob(job);
                  setOpen(true);
                }}
                className="nav-link contact--button active edit-section"
              >
                Edit
              </button>
              </div>
            </div>
          ))}

        </div>
      </div>

      {/* EDIT MODAL */}
      <Modal isOpen={open} onClose={() => setOpen(false)}>
        <h3>Update Job Opening CRM</h3>

        <form onSubmit={updateJob} className="form-gap">
          <div className="from-gap-col">
            <input className="form-control contacts-input" name="position" value={form.position} onChange={handleChange} />
            <input className="form-control contacts-input" name="location" value={form.location} onChange={handleChange} />
            <input className="form-control contacts-input" name="type" value={form.type} onChange={handleChange} />
             <input className="form-control contacts-input" name="department" value={form.department} onChange={handleChange} />
          </div>

          <div className="from-gap-col">
            <textarea className="form-control contacts-input" name="requirements" value={form.requirements} onChange={handleChange} />
            <textarea className="form-control contacts-input" name="responsibilities" value={form.responsibilities} onChange={handleChange} />
        
            <textarea className="form-control contacts-input" name="skills" value={form.skills} onChange={handleChange} />
          </div>

          <button type="submit" className="primary-button full-width-mobile w-button">Update</button>
        </form>
      </Modal>
    </div>
  );
}
